import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { VerificationStatus } from "@tradersage/shared";
import { auth } from "@/util/firebase";

export const Route = createFileRoute("/_auth/verification")({
  component: VerificationStatusPage,
  staticData: {
    title: "Verify Your Email",
  },
});

function VerificationStatusPage() {
  const navigate = useNavigate();

  return (
    <VerificationStatus
      auth={auth}
      onVerified={() => navigate({ to: "/dashboard" })}
      onSignInClick={() => navigate({ to: "/signin" })}
    />
  );
}
